import { AddTransferTypePanel } from "@/components/organisms";

export const TransferTypesAdd = () => {
  return <AddTransferTypePanel />;
};
